
export default [
  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard-v2/Main.vue'),
    meta: {
      module: 'dashboard'
    }
  },
  {
    path: '/dashboard-v2',
    name: 'dashboard',
    component: () => import('@/views/dashboard-v2/Main.vue'),
    meta: {
      module: 'dashboard'
    }
  },
  {
    path: '/dashboard/settings',
    name: 'Dashboard.setSettings',
    
    component: () => import('@/views/dashboard/settings/DashBoardSettings.vue'),
    meta: {
      module: 'Dashboard.setSettings',
      pageTitle: 'Dashboard Settings',
      breadcrumb: [
        { text: 'Dashboard Settings', active: true }
      ],
    }
  },

]
